var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-modal-register-view px-2" },
    [
      _c("div", { staticClass: "mb-5 text-center" }, [
        _c("p", { staticClass: "font-weight-bold font-size-200 mb-0" }, [
          _vm._v(_vm._s(_vm._f("trans")("Create your account"))),
        ]),
      ]),
      _vm._v(" "),
      _c("SocialSignupButtons", {
        staticClass: "mb-4 w-100 text-center d-flex flex-column gap-10",
        attrs: { "reload-page": false },
        on: { "auth-success": _vm.onSocialAuthSuccess },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mb-4 text-center py-2" }, [
        _c("strong", [
          _vm._v(
            _vm._s(_vm._f("trans")("Or sign up using your e-mail address")) +
              ":"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mb-5 d-flex flex-column gap-10",
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.attemptRegister.apply(null, arguments)
            },
          },
        },
        [
          _c("TextInput", {
            attrs: {
              "data-user-modal-input-email": "",
              type: "email",
              name: "u_email",
              label: _vm._f("trans")("E-Mail"),
              icon: "far fa-envelope",
              disabled: _vm.isSubmitting,
              "has-error": _vm.emailError !== null,
              "current-error": _vm.emailError,
              "trim-input": true,
              autocomplete: "email",
            },
            on: { input: _vm.updateEmail },
            model: {
              value: _vm.emailValue,
              callback: function ($$v) {
                _vm.emailValue = $$v
              },
              expression: "emailValue",
            },
          }),
          _vm._v(" "),
          _c("TextInput", {
            attrs: {
              "data-user-modal-input-password": "",
              type: "password",
              name: "u_password",
              label: _vm._f("trans")("Password"),
              icon: "far fa-lock",
              disabled: _vm.isSubmitting,
              "has-error": _vm.passwordError !== null,
              "current-error": _vm.passwordError,
              "trim-input": false,
              autocomplete: "new-password",
            },
            on: { input: _vm.updatePassword },
            scopedSlots: _vm._u([
              {
                key: "after-input",
                fn: function () {
                  return [
                    _c("PasswordStrengthMeter", {
                      staticClass: "pull-right pr-4 pt-2 pb-3 pl-2",
                      attrs: { password: _vm.passwordValue },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "after-error",
                fn: function () {
                  return [
                    _c("span", {
                      staticClass: "clearfix w-100 d-block",
                      staticStyle: { "min-height": "1px" },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "SimpleCheckbox",
            {
              staticClass: "mt-4 card",
              class: { "vuetiful-input-error": _vm.tosError !== null },
              staticStyle: { padding: "10px" },
              attrs: {
                "data-user-modal-input-tos": "",
                name: "u_tos",
                align: "center",
                disabled: _vm.isSubmitting,
                "has-error": _vm.tosError !== null,
                "current-error": _vm.tosError,
              },
              on: { input: _vm.updateTosValue },
            },
            [
              _c("span", {
                staticClass: "tos-links-bold",
                domProps: { innerHTML: _vm._s(_vm.tosText) },
              }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ButtonWithLoadingState", {
        staticClass:
          "btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded mb-4",
        attrs: {
          "data-user-modal-button-submit": "",
          icon: "fa fa-user-plus",
          text: _vm._f("trans")("Sign up"),
          "is-state-loading": _vm.isSubmitting,
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.attemptRegister.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm._f("trans")("Having trouble?")) +
            "\n        "
        ),
        _c(
          "a",
          {
            attrs: { "data-user-modal-link-help": "", href: "" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.goToHelpPage.apply(null, arguments)
              },
            },
          },
          [_vm._v(_vm._s(_vm._f("trans")("Get help")))]
        ),
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "mb-4 mt-4" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("trans")("Already have an account?")) +
              "\n        "
          ),
          _c(
            "RouterLink",
            {
              attrs: {
                "data-user-modal-link-login": "",
                to: { name: _vm.userModalRoute.LOGIN },
                disabled: _vm.isSubmitting,
                event: _vm.isSubmitting ? "" : "click",
                tag: "a",
              },
            },
            [_vm._v(_vm._s(_vm._f("trans")("Log in")) + "\n        ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }